import * as types from "../types_activation";
import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  activation: {
    isLoading: false,
    isError: false,
    data: null,
    filter: {
      purchaseDate_From: "",
      code: "",
      purchaseDate_To: "",
      partyEmail: "",
      partyName: "",
      partyType: [],
      partner: ["repbase"],
      transactionType: [],
    },
    activationId: -1,
  },
};

const getters = {
  isError: (state) => {
    return state.activation.isError;
  },
  isLoading: (state) => {
    return state.activation.isLoading;
  },
  actData: (state) => {
    return state.activation.data;
  },
  filter: (state) => {
    return state.activation.filter;
  },
};

const actions = {
  [types.ACT_ACTION_FILTER_EMAIL]: ({ commit }, payload) => {
    commit(types.ACT_MUTATION_CLEAR_FILTER, payload);
    commit(types.ACT_MUTATION_FILTER_EMAIL, payload);
  },

  [types.ACT_ACTION_CLEAR_FILTER]: ({ commit }, payload) => {
    commit(types.ACT_MUTATION_CLEAR_FILTER, payload);
  },

  setFilter: (context, payload) => {
    context.state.activation.filter = payload;
    context.state.activation.isError = false;
    context.state.activation.isLoading = true;

    axios({
      method: "POST",
      url: "/activationCode/filter",
      data: context.state.activation.filter,
      headers: authHeader(),
    })
      .then((res) => {
        // console.log(res.data);
        context.state.activation.data = res.data;
        context.state.activation.isError = false;
        context.state.activation.isLoading = false;
      })
      .catch((error) => {
        context.state.activation.isLoading = false;
        context.state.activation.isError = true;
        console.error("Activation filter error:", error);
      });
  },

  refresh: (context) => {
    context.state.activation.isLoading = true;
    context.state.activation.isError = false;
    axios({
      method: "POST",
      url: "/activationCode/filter",
      data: context.state.activation.filter,
      headers: authHeader(),
    })
      .then((res) => {
        context.state.activation.data = res.data;
        context.state.activation.isError = false;
        context.state.activation.isLoading = false;
      })
      .catch((error) => {
        context.state.activation.isLoading = false;
        context.state.activation.isError = true;
        console.error("Activation refresh error:", error);
      });
  },

  create: (context, payload) => {
    // console.log({ payload });
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/activationCode/create",
        data: payload,
        headers: authHeader(),
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete: (context, activationId) => {
    // console.log({ activationId });
    return new Promise((resolve, reject) => {
      //context.state.subscription.filter = payload;
      context.state.activation.isLoading = true;
      axios({
        method: "POST",
        url: "/activationCode/delete",
        data: { activationCodeId: activationId },
        headers: authHeader(),
      })
        .then((res) => {
          // console.log(res.data);
          // context.state.activation.data = res.data;
          context.state.activation.isLoading = false;
          resolve(res.data);
        })
        .catch((error) => {
          context.state.activation.isLoading = false;
          context.state.activation.isError = true;
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Failed to delete activation code."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/activation.js